import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "~/atoms/tooltip";
import { TagsValue } from "~/molecules/Tags";

export type ItemsTooltipVariant = "category" | "tag";

interface Props {
  items: string[];
  variant: ItemsTooltipVariant;
  children: ReactNode;
}

const ItemsTooltip = ({ items, variant, children }: Props) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent className="bg-popover border-border text-popover-foreground flex flex-col gap-1.5 border p-2">
        {items.map((item) =>
          variant === "tag" ? (
            <TagsValue key={item}>{item}</TagsValue>
          ) : (
            <p key={item}>{item}</p>
          ),
        )}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default ItemsTooltip;
